export default __webpack_public_path__ + "static/media/envelope-white.f17ea4c8.svg";